<template>
  <div>
    <Header></Header>
    <main id="content" role="main">
      <!-- Hero Section -->
      <div class="bg-primary bg-img-hero">
        <div class="container space-2 space-lg-3">
          <div class="w-lg-65 text-center mx-lg-auto">
            <span
              class="badge badge-soft-light badge-pill font-size-1 py-3 px-4 mb-3"
              >行业方案</span
            >
            <h1 class="text-white mb-0" >  {{detalContent.title}}  </h1>
          </div>
        </div>
      </div>
      <!-- End Hero Section -->

      <!-- SVG Bottom Shape -->
      <figure>
        <svg
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="100%"
          height="64px"
          viewBox="0 0 1921 273"
          style="margin-bottom: -8px; enable-background: new 0 0 1921 273"
          xml:space="preserve"
        >
          <polygon fill="#f9fbff" points="1921,0 0,0 0,273 " />
        </svg>
      </figure>
   
      <div  class="container img-width" v-if="detalContent" v-html="detalContent.content"></div>


      <div class="container space-lg-1 " style="border-top:1px solid #dee2e6;margin-top:50px">
		
	
		
     <!-- Icon Blocks Section -->
     <div class="overflow-hidden">
       <div class="container space-2 space-top-lg-1">
         <!-- Title -->
         <div class="w-md-80 w-lg-50 text-center mx-md-auto mb-5 mb-md-9">
           <span class="d-block ont-weight-bold text-cap mb-2">核心优势/技术栈</span>
           <h2>更直观的分析，让决策更明智</h2>
         </div>
         <!-- End Title -->
     
         <div v-if="svglist" class="row">
           <div v-for="(item,index) in svglist" :key="index" class="col-sm-4 mb-3 mb-sm-5">
             <!-- Icon Blocks -->
             <div class="pr-lg-6">
               <figure class="max-w-6rem w-100 mb-3">
                 <img class="img-fluid" :src="getVg(item.filePath)" alt="SVG" >
               </figure>
               <h4>{{item.title}}</h4>
               <p>{{item.description}}</p>
             </div>
             <!-- End Icon Blocks -->
           </div>
         </div>
     
         <!-- SVG Shapes -->
         <figure class="position-absolute z-index-n1" style="top: -35rem; left: 50rem; width: 62rem; height: 62rem;">
           <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 260 260">
             <circle fill="#e7eaf3" opacity=".7" cx="130" cy="130" r="130"/>
           </svg>
         </figure>
         <!-- End SVG Shapes -->
       </div>
     </div>
     <!-- End Icon Blocks Section -->
          <!-- End Icon Block -->
        </div>


      <!-- Stories Section -->
      <div class="container space-1">
        <!-- Title -->
        <div class="w-md-80 w-lg-40 text-center mx-md-auto mb-5 mb-md-9">
          <h2>更多行业方案</h2>
        </div>
        <!-- End Title -->

        <div class="row">
          <div class="col-sm-6 col-md-4 mb-5" v-for="item in contentList1" :key="item.contentId">
            <!-- Card Info -->
            <div class="card h-100"  @click="skip(item.contentId)" style="cursor:pointer">
              <img
                v-if="item.imgsrc"
                class="card-img-top"
                :src="getImgUrl(item.imgsrc)"
                alt="Image Description"
              />
              <div class="card-body">
                <p class="mb-0">{{item.title}}</p>
              </div>
              <div class="card-footer">
                <a class="font-weight-bold"
                  style="cursor:pointer;color:#0052ea" 
                 
                  >查看方案<i class="fas fa-angle-right fa-sm ml-1"></i
                ></a>
              </div>
            </div>
            <!-- End Card Info -->
          </div>
        </div>
      </div>
      <!-- End Stories Section -->

      <!-- CTA Section -->
      <div class="bg-primary text-center bg-img-hero">
        <div class="container space-2">
          <div class="mb-5">
            <h3 class="h2 text-white">索取更多案例/解决方案请与商务经理联系</h3>
          </div>
          <router-link class="btn btn-light transition-3d-hover"  to="/contact"
            >联系我们</router-link
          >
        </div>
      </div>
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import "@/assets/vendor/jquery/dist/jquery.min.js";
import "@/assets/vendor/jquery-migrate/dist/jquery-migrate.min.js";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "@/assets/vendor/font-awesome/css/all.min.css";
import "@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.css";
import "@/assets/css/theme.css";
import AOS from "aos";
import "@/assets/vendor/hs-header/dist/hs-header.min.js";
import "@/assets/vendor/hs-go-to/dist/hs-go-to.min.js";
import "@/assets/vendor/hs-unfold/dist/hs-unfold.min.js";
import "@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.js";
import "@/assets/vendor/hs-show-animation/dist/hs-show-animation.min.js";
import "@/assets/vendor/jquery-validation/dist/jquery.validate.min.js";
import "@/assets/vendor/slick-carousel/slick/slick.js";
import "@/assets/js/hs.core.js";
import "@/assets/js/hs.validation.js";
import Header from "../components/header";
import Footer from "../components/footer";
import { getsy, getsycolumn, getPostDetail,getsyres ,getcontent,getSvgList} from "../request/index";
export default {
  components: {
    Header,
    Footer,
  },
  data(){
    return{
      detalContent:{
        title:'物流园区管理综合解决方案'
      },
      collist:[],
      contentList:[],
      contentList1:[],
      svglist:[],
      svgobj:{
        one:[],two:[],three:[]
      }
    }
  },
  mounted() {
    // window.addEventListener("scroll", this.handleScroll);
    $(document).ready(function () {
      //   console.log("ccccc",HSHeader)
      //   var header = new HSHeader($("#header")).init();

      // initialization of mega menu
      var megaMenu = new HSMegaMenu($(".js-mega-menu"), {
        desktop: {
          position: "left",
        },
      }).init();

      // initialization of unfold
      var unfold = new HSUnfold(".js-hs-unfold-invoker").init();

      // initialization of fancybox
      $(".js-fancybox").each(function () {
        var fancybox = $.HSCore.components.HSFancyBox.init($(this));
      });

      // initialization of circles
      $(".js-circle").each(function () {
        var circle = $.HSCore.components.HSCircles.init($(this));
      });

      //initialization of aos
      AOS.init({
        duration: 650,
        once: true,
      });
      // if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) document.write('<script src="@/assets/vendor/polifills.js"><\/script>');
      // initialization of go to
      $(".js-go-to").each(function () {
        var goTo = new HSGoTo($(this)).init();
      });
      $(".js-counter").each(function () {
        var counter = new HSCounter($(this)).init();
      });
    });
  },
  created(){
    if(this.$route.query.columnId){
      this.getContent(this.$route.query.columnId)
    }
    if(this.$route.query.contentId){
      this.getFromContentId(this.$route.query.contentId)
    }
    
  },
  watch:{
    '$route'(to,from) {
      this.detalContent =null;this.collist = [];this.contentList = [];this.contentList1=[]
      if(to.query.contentId){
        this.getFromContentId(to.query.contentId)
      }else{
        this.getContent(to.query.columnId)
      }
    }
  },
  methods:{
    getContent(id){
       getsy(id).then(res=>{
        console.log(355,res)
        this.detalContent = res.data.content[0]
        this.getImgResouce(res.data.content[0],res.data.content[0].contentId,true)
        this.getSvg(res.data.content[0].contentId)
        this.getMore()
      })
    },
    getFromContentId(id){
      getcontent(id).then(res=>{
        this.detalContent = res.data.content[0]
        this.getImgResouce(res.data.content[0],res.data.content[0].contentId,true)
        this.getSvg(res.data.content[0].contentId)
        this.getMore()
      })
    },
    getMore(){
      getsycolumn(0).then(res=>{
        let arr = res.data
        arr.forEach(item=>{
          if(item.type == "行业方案"){
            this.collist.push(item.columnId)
            getsycolumn(item.columnId).then(hs=>{
              let ar1 = hs.data
              ar1.forEach(ts=>{this.collist.push(ts.columnId)})
              this.getMoreContent(this.collist)
            })
          }
        })
      })
    },
    // 通过栏目id查询内容
    getMoreContent(arr){
      getPostDetail(arr).then(res=>{
        this.contentList = res.data
        let z =0
        console.log(292,res)
        this.contentList.forEach((item,i)=>{
          if(item.contentId != this.detalContent.contentId){
            if(z>=3){return}else{
              z = z +1
              this.getImgResouce(item,item.contentId,false )
            }
          }
        })
      })
    },
    // 通过内容id获取资源
    getImgResouce(obj,id,bol){
      getsyres(id).then(res=>{
        let arr = res.data
        console.log(arr)
        if(arr && arr.length>0){
          arr.forEach(hs=>{
            if(!bol){
              if(hs.keystring == "封面"){obj.imgsrc = hs.fileId;this.contentList1.push(obj)}
            }else{
            }
          })
        }
      })
    },
    // 通过内容id查看svg列表
    getSvg(id){
      getSvgList({contentId:id,page:0,size:999}).then(res=>{
        console.log(306,res)
        if(res.data.content.length>0){
          this.svglist = res.data.content.sort((a,b)=>{return a.tag-b.tag})
        }
      })
    },
    // 图片地址
    getImgUrl(id){
      return process.env.NODE_URL + "api/files/getFileStream?fileId="+id
    },
    getVg(url){return process.env.NODE_URL +'file/图片/'+ url},
    // 图片地址
    getSvgUrl(id){
      let url = id.replace('/file','file')
      return process.env.NODE_URL + url
    },
    skip(id){
      this.detalContent = null
      this.contentList1 = [];
      this.contentList = [];
      this.$router.push({path:'/plan',query:{contentId:id}})
    },
  }
};
</script>

<style scoped>
.bg-img-hero {
  background: url("../assets/svg/components/abstract-shapes-5.svg") no-repeat  top center;
  background-size:cover ;
}

</style>


// WEBPACK FOOTER //
// src/view/plan.vue